<template>
    <div>
        <template v-if="asset">
            <div class="custom-container">
                <router-link to="/login"
                             v-if="$store.state.user.role.name === 'guest'">
                    <vs-button radius icon-pack="feather" size="large" icon="icon-log-in" class="fixed-button"/>
                </router-link>
                <router-link :to="'/' + asset._id + '/edit'"
                             v-if="$store.state.user.role.name === 'Manager' || $store.state.user.role.name === 'Media' || $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'">
                    <vs-button radius icon-pack="feather" size="large" icon="icon-edit" class="fixed-button"/>
                </router-link>
                <vx-card class="mb-base">
                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-full md:w-2/3">
                        <div>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Name
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <vs-input
                                name="name"
                                v-validate="$route.params.id ? 'required' : 'required'"
                                placeholder="Name"
                                v-model="asset.title"
                              />
                              <span class="text-danger text-sm validation-error" v-show="errors.has('name')"
                                    v-html="errors.first('name')"></span>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                {{currentLanguage.name}}
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <vs-input
                                name="name"
                                placeholder="Name"
                                v-model="asset.locales[currentLanguage.code].name"
                              />
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Description
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <div class="resize-vertical vs-textarea custom-textarea">
                                {{ asset.description }}
                              </div>
                              <span class="text-danger text-sm validation-error"
                                    v-show="errors.has('description')">{{ errors.first('description') }}</span>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                {{currentLanguage.name}}
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <div class="resize-vertical vs-textarea custom-textarea">
                                {{ asset.locales[currentLanguage.code].description }}
                              </div>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Primary Tags
                              </div>
                            </template>
                            <div class="d-flex no-edit">
                              <v-select ref="primary_tags" taggable multiple v-model="asset.primary_keywords"
                                        :select-on-key-codes="[13]"/>

                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                {{currentLanguage.name}}
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <v-select ref="tags" taggable multiple v-model="asset.locales[currentLanguage.code].primary_tags"
                                        :select-on-key-codes="[13]"/>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Tags
                              </div>
                            </template>
                            <div class="d-flex no-edit">
                              <v-select ref="tags" taggable multiple v-model="asset.keywords"
                                            :select-on-key-codes="[13]"/>

                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                {{currentLanguage.name}}
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <v-select ref="tags" taggable multiple v-model="asset.locales[currentLanguage.code].tags"
                                        :map-keydown="(map, vm) => handleCreatedTag(map, vm, `tags`, currentLanguage.code)"
                                        :select-on-key-codes="[13]"/>
                            </div>
                          </vx-input-group>
                          <vs-divider/>
                          <div class="vx-row no-edit">
                            <div class="vx-col w-full sm:w-full md:w-1/2">
                              <vx-input-group class="custom-input-group mb-0">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    Type
                                  </div>
                                </template>
                                <div class="d-flex">
                                  <v-select name="type"
                                            v-validate="'required'" :options="types"
                                            v-model="asset.asset_type"
                                            :reduce="item => item.value" label="name"/>
                                  <span class="text-danger text-sm validation-error"
                                        v-show="errors.has('type')">{{ errors.first('type') }}</span>

                                </div>
                              </vx-input-group>
                            </div>
                            <div class="vx-col w-full sm:w-full md:w-1/2">
                              <vx-input-group class="custom-input-group mb-0">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    Subject
                                  </div>
                                </template>

                                <div class="d-flex">
                                  <v-select name="subject" multiple :options="$store.state.subjects"
                                            v-model="asset.subject" :reduce="item => item" label="name"/>
                                  <vx-tooltip
                                    class="help-tip"
                                    position="right"
                                    text="Subject that best matches the asset">
                                    <i class="material-icons notranslate"> help_outline </i>
                                  </vx-tooltip>
                                </div>
                              </vx-input-group>
                            </div>
                          </div>
                          <vs-divider/>
                          <div class="vx-row">
                            <div class="vx-col w-full sm:w-full md:w-1/2">
                              <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    Academic Reviewed
                                  </div>
                                </template>

                                <div class="d-flex no-edit">
                                  <div class="vx-input-group-append flex-grow">
                                    <div class="append-text btn-addon">
                                      <vs-button
                                        color="primary"
                                        type="border"
                                        @click="setAcademicReviewed(true)"
                                        class="radiobtn"
                                        :class="{selected: asset.academic_reviewed}">
                                        Yes
                                      </vs-button>
                                      <vs-button
                                        color="primary"
                                        type="border"
                                        @click="setAcademicReviewed(false)"
                                        class="radiobtn"
                                        :class="{selected: !asset.academic_reviewed}">
                                        No
                                      </vs-button>
                                    </div>
                                  </div>
                                  <span class="text-danger text-sm validation-error"
                                        v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                </div>
                              </vx-input-group>

                            </div>
                            <div class="vx-col w-full sm:w-full md:w-1/2">
                              <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    Artist Reviewed
                                  </div>
                                </template>

                                <div class="d-flex no-edit">
                                  <div class="vx-input-group-append flex-grow">
                                    <div class="append-text btn-addon">
                                      <vs-button
                                        color="primary"
                                        type="border"
                                        @click="setArtistReviewed(true)"
                                        class="radiobtn"
                                        :class="{selected: asset.artist_reviewed}">
                                        Yes
                                      </vs-button>
                                      <vs-button
                                        color="primary"
                                        type="border"
                                        @click="setArtistReviewed(false)"
                                        class="radiobtn"
                                        :class="{selected: !asset.artist_reviewed}">
                                        No
                                      </vs-button>
                                    </div>
                                  </div>
                                  <span class="text-danger text-sm validation-error"
                                        v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                </div>
                              </vx-input-group>
                            </div>
                          </div>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Visibility
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setVisibility('internal_only')"
                                    class="radiobtn"
                                    :class="{selected: visibility == 'internal_only'}">
                                    Internal Only
                                  </vs-button>
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setVisibility('b2b')"
                                    class="radiobtn"
                                    :class="{selected: visibility == 'b2b'}">
                                    B2B
                                  </vs-button>
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setVisibility('public')"
                                    class="radiobtn visibility-public-btn"
                                    :class="{selected: visibility == 'public'}">
                                    Public
                                  </vs-button>
                                </div>
                              </div>
                              <span class="text-danger text-sm validation-error"
                                    v-show="errors.has('test')">{{ errors.first('test') }}</span>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                Readiness
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    class="radiobtn"
                                    :class="{selected: !asset.published}">
                                    Draft
                                  </vs-button>
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    class="radiobtn published-btn"
                                    :class="{selected: asset.published}">
                                    Published
                                  </vs-button>
                                </div>
                              </div>
                              <span class="text-danger text-sm validation-error"
                                    v-show="errors.has('test')">{{ errors.first('test') }}</span>
                            </div>
                          </vx-input-group>
                          <vx-input-group class="custom-input-group">
                            <template slot="prepend">
                              <div class="prepend-text bg-dark">
                                AR Readiness
                              </div>
                            </template>

                            <div class="d-flex no-edit">
                              <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    class="radiobtn"
                                    :class="{selected: !asset.ar_reviewed}">
                                    Draft
                                  </vs-button>
                                  <vs-button
                                    color="primary"
                                    type="border"
                                    class="radiobtn published-btn"
                                    :class="{selected: asset.ar_reviewed}">
                                    Published
                                  </vs-button>
                                </div>
                              </div>
                            </div>
                          </vx-input-group>
                        </div>
                      </div>
                        <div class="vx-col w-full sm:w-full md:w-1/3">
                          <div class="d-flex justify-end mb-2 align-center">
                            <div class="mr-3">Language</div>
                            <v-select
                              ref="currentLanguage"
                              class="hide-search break-word"
                              name="currentLanguage"
                              :options="[{ name: 'English (India)', code: 'en' }, ...$store.state.languages]"
                              v-model="currentLanguage"
                              label="name"
                              :searchable="false"
                              :clearable="false"
                              style="width: 150px; height: 38px;"
                              :reduce="item => item"/>
                          </div>
                            <div class="asset-thumbnail-section">
                                <div class="asset-thumbnail-section">
                                    <HoverThumb
                                        :asset="asset"
                                        :main="asset.thumbnail"
                                        img-class-name="responsive card-img-top"
                                        :list="asset.thumbnails"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </vx-card>

                <div v-if="asset.variants.length > 0 && asset.variants.find(item => item._id === asset.published_variant)" class="variations-section" :class="{'view-variation': Boolean($route.params.variation_id)}">
                    <div class="dfaicjcsb mb-base">
                        <h3>Variations</h3>
                    </div>
                    <div v-if="false">
                        <template v-for="(item, index) in asset.variants" v-if="item._id == $route.params.variation_id">
                            <vx-card :title="item.name" :subtitle="item.description" class="details-card" :key="index">
                                <div class=" vx-row">
                                    <div class="vx-col w-full sm:w-1/2 md:w-1/3">
                                        <div>
                                            <div class="drop-down-field">Updated by: {{ item.approved_by }}</div>
                                            <div class="drop-down-field">Last updated: {{ getDateFormat(item.updatedAt) }}
                                            </div>
                                            <div class="drop-down-field" v-if="item.visual_style">Visual Style: {{ item.visual_style }}
                                            </div>
                                            <vs-divider style="margin: 0"/>
                                            <div class="drop-down-field">Is animated: {{ item.is_animated ? 'Yes' : 'No'
                                                }}
                                            </div>
                                            <div class="drop-down-field">Language: {{ item.language }}</div>
                                            <div class="drop-down-field" v-if="item.duration">Duration: {{ getDuration(item.duration) }}</div>
                                            <div class="drop-down-field">Source size: {{ formatBytes(item.source_links) }}
                                            </div>
                                            <div class="drop-down-field">Output size: {{ formatBytes(item.ready_links) }}
                                            </div>
                                            <vs-divider style="margin: 0"/>
                                            <div class="drop-down-field" v-if="item.notes">Notes: {{ item.notes }}</div>
                                            <vs-divider style="margin: 0"/>
                                            <div class="flex" style="margin: 10px 0">
                                                <vs-button class="action-metadata-btn" color="success" type="gradient"
                                                           @click="editVariation" style="margin-right: 5px;"
                                                           v-if="$store.state.user.role.name === 'Media' || $store.state.user.role.name === 'Manager'">
                                                    <i translate="translate" class="material-icons notranslate"> edit </i>
                                                </vs-button>
                                                <vs-button color="danger" type="gradient" class="action-metadata-btn"
                                                           @click="deleteElement('variants', index)"
                                                           v-if="$store.state.user.role.name === 'Manager'">
                                                    <i translate="translate" class="material-icons notranslate"> clear </i>
                                                </vs-button>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex justify-between flex-wrap variation-btns">
                                                <vs-progress :percent="progressValue(index, 'source')" color="dark"
                                                             v-if="progressData['source'][index]"></vs-progress>
                                                <vs-button type="gradient" color="#7367F0"
                                                           gradient-color-secondary="#CE9FFC"
                                                           style="flex-grow: 1;"
                                                           @click="download(item.source_links, index, 'source')"
                                                           :class="`download-source-${index}`"
                                                           v-if="item.source_links && item.source_links.length > 0"
                                                >
                                                    <span v-if="!progressData['source'][index]">Download Source</span>
                                                    <span v-else>{{downloadedStr(progressData['source'][index])}}</span>
                                                </vs-button>
                                            </div>
                                            <div class="mt-4"></div>
                                            <div class="flex justify-between flex-wrap variation-btns">
                                                <vs-progress :percent="progressValue(index, 'ready')" color="dark"
                                                             v-if="progressData['ready'][index]"></vs-progress>
                                                <vs-button type="gradient" color="#7367F0"
                                                           gradient-color-secondary="#CE9FFC" style="flex-grow: 1;"
                                                           @click="download(item.ready_links, index, 'ready')"
                                                           v-if="item.ready_links && item.ready_links.length > 0"
                                                           :class="`download-ready-${index} coobo-ready-btn`">
                                                    <span v-if="!progressData['ready'][index]">Download Coobo-ready</span>
                                                    <span v-else>{{downloadedStr(progressData['ready'][index])}}</span>

                                                </vs-button>
                                            </div>
                                            <div class="mt-4 flex justify-between flex-wrap"
                                                 v-if="asset.asset_type === '3D'">
                                                <a :href="item.coobo_library_link" target="_blank" style="flex-grow: 1;"
                                                   v-if="item.coobo_library_link">
                                                    <vs-button type="gradient" color="#7367F0"
                                                               gradient-color-secondary="#CE9FFC" style="width: 100%">View
                                                        asset link
                                                    </vs-button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col w-full  sm:w-1/2 md:w-2/3">
                                        <div class="custom-input-group" v-if="item.coobo_library_link" style="height: 100%">
                                            <iframe ref="libraryIframe" class="library-iframe"
                                                    :src="item.coobo_library_link + '?hq'" allowfullscreen></iframe>
                                        </div>
                                        <div slot="no-body" class="card-img-block" v-if="!item.coobo_library_link">
                                            <div class="asset-img-section variant-view-img">
                                                <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(asset.asset_type)"
                                                     alt="content-img" class="responsive card-img-top">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vx-card>
                        </template>
                    </div>
                    <div class="vx-row" style="display: flex; flex-wrap: wrap">
                        <div v-for="(item, index) in asset.variants" :key="index"
                             class="vx-col w-full  sm:w-1/2 lg:w-1/3 xl:w-1/4"
                             :class="{'active-variation': $route.params.variation_id === item._id}"
                             v-if="store.state.user.role.name !== 'Authenticated' || item._id === asset.published_variant"
                        >
                            <VariantItem
                                :published="currentLanguage.code === 'en' || (!asset.published_variant_langs && !(currentLanguage.code in asset.published_variant_langs)) ? item._id === asset.published_variant :
                                   (asset.published_variant_langs && currentLanguage.code in asset.published_variant_langs) ?
                                    item._id === asset.published_variant_langs[currentLanguage.code] : item._id === asset.published_variant"
                                :item="item"
                                :asset="assetData"
                                :index="index"
                                :open-asset-popup="openAssetPopup"
                            />
                        </div>
                    </div>
                </div>
                <div class="vx-row" v-if="metaKg && metaKg.length > 0">
                    <div class="vx-col w-full" v-if="asset.subject !== 'Generic'">
                        <vx-card>
                            <div class="dfaicjcsb mb-base">
                                <h3>Academic metadata</h3>
                                <div v-if="asset && metaKg && metaKg.length">
                                    <v-select :options="$store.state.learningMapFormats"
                                              :reduce="item => item.id"
                                              label="name"
                                              v-model="learningMapFormat"
                                              style="min-width: 300px"
                                    />
                                </div>
                            </div>
                          <div>
                            <div id="meta-container" style="min-height: 30px; margin-top: 20px" class="relative">
                              <table class="meta-table mt-3">
                                <thead>
                                <th style="width: 7%">Concept</th>
                                <th style="width: 15%">Title</th>
                                <!--                                        <th style="width: 3%">Grade</th>-->
                                <th style="width: 10%">Exam</th>
                                <th style="width: 10%">Subject</th>
                                <th style="width: 15%">Unit</th>
                                <th style="width: 20%">Chapter</th>
                                <th style="width: 20%">Topic</th>
                                </thead>
                                <tbody>
                                <tr v-if="!metaKg.filter(item => item[currentLanguage.code === 'en' ? 'learning_map' : `learning_map_${currentLanguage.code}`] ? item[currentLanguage.code === 'en' ? 'learning_map' : `learning_map_${currentLanguage.code}`].find(el => el.lm_format_id === learningMapFormat) : null).length">
                                  <td colspan="7" style="text-align: center">
                                    No data available
                                  </td>
                                </tr>
                                <tr v-for="(item, index) in getSortedMetakg(metaKg)" :key="index">
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item.concept_id}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input d-flex">
                                        {{currentLanguage.code !== 'en' ? item['title_' + currentLanguage.code] ? item['title_' + currentLanguage.code] : item.title : item.title}}
                                        <vx-tooltip
                                          class="am-tooltip"
                                          position="bottom"
                                          :text="item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).join(', ')"
                                          v-if="item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && (!item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) || !item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['exam']) && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).length"
                                        >
                                          <div class="am-tooltip-count">{{ item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).length }}</div>
                                        </vx-tooltip>
                                      </div>
                                    </div>
                                  </td>
                                  <!--                                            <td>-->
                                  <!--                                                <div>-->
                                  <!--                                                    <div class="table-input">-->
                                  <!--                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['grade'] : ''}}-->
                                  <!--                                                    </div>-->
                                  <!--                                                </div>-->
                                  <!--                                            </td>-->
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['exam'] : ''}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['subject'] : ''}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['unit'] : ''}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['chapter'] : ''}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['topic'] : ''}}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div v-if="asset && primaryConcepts && primaryConcepts.length">
                            <div class="mt-5 dfaicjcsb mb-base">
                              <h3>Primary concept</h3>
                            </div>
                            <div>
                              <div id="meta-container2" style="min-height: 30px; margin-top: 20px" class="relative">
                                <table class="meta-table mt-3">
                                  <thead>
                                  <th style="width: 45%">Concept</th>
                                  <th style="width: 55%">Title</th>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(primaryConcept, index) in primaryConcepts" :key="index">
                                    <td>
                                      <div>
                                        <div class="table-input">
                                          {{primaryConcept.concept_id}}
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <div class="table-input d-flex">
                                          {{primaryConcept.title}}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </vx-card>
                    </div>
                    <div class="vx-col w-full" v-if="false && asset.subject !== 'Generic'">
                        <vx-card>
                            <div class="dfaicjcsb mb-base">
                                <h3>Academic KGC metadata</h3>
                            </div>
                            <div>
                                <div id="meta-kgc-container" style="min-height: 30px; margin-top: 20px" class="relative">
                                    <table v-if="asset.meta_KGC && asset.meta_KGC.length > 0"
                                           class="meta-table mt-3">
                                        <thead>
                                        <th>Concept</th>
                                        <th style="width: 70%">Title</th>
                                        <th>KG Code</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in asset.meta_KGC" :key="index">
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.concept_id}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.title === "kgtitle" ? "" : item.title}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.kg_code}}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>

                <vx-card v-if="related_assets.length > 0">
                    <h3 class="mb-base">Related Assets</h3>
                    <div class="vx-row">
                        <div
                            class="vx-col related-item custom-asset-card mb-base w-full sm:w-1/2 md:w-1/4 lg:w-1/6 xl:w-1/6"
                            v-for="(item, index) in related_assets" :key="index">
                            <AssetItem :item="item"/>
                        </div>
                    </div>
                </vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-full md:w-1/2">
                        <vx-card>
                            <h3 style="margin-bottom: 20px">Sourcing</h3>
                            <vx-input-group class="mb-4 custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        License Type
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        disabled="true"
                                        placeholder="License Type"
                                        v-model="asset.license_type"
                                    />
                                </div>
                            </vx-input-group>
                            <vx-input-group class="mb-4 custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Partner
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        disabled="true"
                                        placeholder="Parther"
                                        v-model="asset.license_partner"
                                    />
                                </div>
                            </vx-input-group>
                            <vx-input-group class="mb-4 custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Source
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        disabled="true"
                                        placeholder="Source"
                                        v-model="asset.license_url"
                                    />
                                </div>
                            </vx-input-group>
                            <vx-input-group class="mb-4 custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Attribution
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        disabled="true"
                                        placeholder="Attribution"
                                        v-model="asset.attribution_text"
                                    />
                                </div>
                            </vx-input-group>
                            <vx-input-group class="mb-4 custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Price
                                    </div>
                                </template>

                                <div class="custom-input" style="display: flex">
                                    <div class="w-full">
                                        <vs-input
                                            disabled="true"
                                            class="price-input"
                                            placeholder="Price"
                                            v-model="asset.price"
                                        />
                                    </div>
                                    <div>
                                        <vs-input
                                            disabled="true"
                                            placeholder="Currency"
                                            v-model="asset.currency"
                                        />
                                    </div>
                                </div>
                            </vx-input-group>
                        </vx-card>
                    </div>
                    <div class="vx-col w-full sm:w-full md:w-1/2">
                        <vx-card>
                            <div>
                                <vx-input-group class="mb-4 custom-input-group" v-if="asset.notes">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Notes
                                        </div>
                                    </template>
                                    <div class="vs-component vs-con-textarea vs-textarea-primary"
                                         style="border: 1px solid rgba(0, 0, 0, 0.08) !important;">
                                        <div class="vs-textarea break-word">{{asset.notes}}</div>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Test
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="asset.is_test = true"
                                                    class="radiobtn"
                                                    disabled
                                                    :class="{selected: asset.is_test}">
                                                    Yes
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="asset.is_test = false"
                                                    class="radiobtn"
                                                    disabled
                                                    :class="{selected: !asset.is_test}">
                                                    No
                                                </vs-button>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('test')">{{ errors.first('test') }}</span>

                                    </div>
                                </vx-input-group>
                            </div>
                        </vx-card>
                    </div>
                </div>
                <asset-meta :asset="asset" v-if="asset && asset.meta"></asset-meta>
                <info v-if="isInfoModal" v-on:closeInfo="closeInfoModal"></info>
            </div>
            <vs-popup fullscreen title="View asset" :active.sync="assetPopupActive" class="iframe-popup" v-on:close="closeViewAsserModal">
                <template v-if="assetPopupActive">
                    <public3d-modal :asset="assetPopupData" v-if="asset.asset_type === '3D'" :renderContent="true" :locale="currentLanguage && currentLanguage.code" />
                    <img :src="assetPopupData" v-if="asset.asset_type === 'image' || asset.asset_type === 'illustration'" />
                    <iframe v-if="asset.asset_type === 'vr_image'" allowfullscreen="" frameborder="0" :src="assetPopupData"/>
                    <video v-if="asset.asset_type === 'video' || asset.asset_type === 'animation'" autoplay controls allowfullscreen="" frameborder="0" :src="assetPopupData"/>
                    <div class="audio-cnt" v-if="asset.asset_type === 'audio'" >
                        <div class="filename">{{assetPopupData.filename}}</div>
                        <audio autoplay controls :src="assetPopupData.src"/>
                    </div>
                    <vs-button radius icon-pack="feather" class="close-view-asset"  size="large" icon="icon-plus" @click="closeViewAsserModal"/>
                </template>
            </vs-popup>
        </template>
        <error404 v-if="isError" :is_page="true"></error404>
        <restore v-if="isRestore" :id="$route.params.id" :getAsset="getAsset" :hide-action="true"></restore>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import 'swiper/dist/css/swiper.min.css'
    import Error404 from './pages/Error404.vue'
    import info from '../components/modal/info.vue'
    import HoverThumb from "../components/HoverThumb";
    import AssetItem from "../components/AssetItem";
    import ObjectHierarchy from "../components/ObjectHierarchy";
    import KGC from "../components/KGC";
    import VariantItem from "../components/VariantItem";
    import axios from 'axios'
    import Restore from './pages/Restore.vue'
    import AssetMeta from "@/components/AssetMeta.vue";
    import store from "../store/store.js";
    import Public3dModal from "@/components/modal/public3dModal.vue";

    export default {
        name: 'ViewAsset',
        components: {
          Public3dModal,
            vSelect,
            AssetItem,
            HoverThumb,
            ObjectHierarchy,
            Error404,
            KGC,
            VariantItem,
            info,
            Restore,
            AssetMeta
        },
        head: {
            title() {
                return {
                    inner: 'AMP',
                    separator: this.header_separator,
                    complement: this.header_component
                }
            },
            meta: [
                {hid: 'description', name: 'description', content: ''}
            ]
        },
        data() {
            return {
                noEdit: false,
                isError: false,
                isRestore: false,
                isInfoModal: false,
                header_separator: ' ',
                header_component: '',
                assetPopupData: "",
                assetPopupActive: false,
                isAddRelatedAsset: false,
                isAddVariation: false,
                deleteItem: null,
                deleteItemType: null,
                types: this.$store.getters.assetTypes,
                asset: null,
                related_assets: [],
                progressData: {
                    source: {},
                    ready: {}
                },
                learningMapFormat: '5ec5867a0c88fe5860961943',
                currentLanguage: {
                  name: 'English',
                  code: 'en'
                },
                visibility: 'internal_only',
            }
        },
        mounted() {
          this.noEdit = this.$route.query["no-edit"] === "true";
          if (this.$route.query["locale"] && this.$route.query["locale"] !== 'en') {
            let tempLanguage = this.$store.state.languages.find(item => item.code === this.$route.query["locale"]);
            if (tempLanguage) {
              this.currentLanguage = tempLanguage
            }
          }
          if (this.$route.query["formatReference"]) {
            let tempLmFormat = this.$store.state.learningMapFormats.find(item => item.id === this.$route.query["formatReference"]);
            if (tempLmFormat) {
              this.learningMapFormat = tempLmFormat.id
            }
          }
          if (this.$route.params.id && !this.$route.params.id.match(/^[0-9a-fA-F]{24}$/)) {
              this.$router.push('/error-404');
              return
          }
          this.getAsset();
        },
        methods: {
          getSortedMetakg(metaKg) {
            let field = this.currentLanguage.code === 'en' ? 'learning_map' : `learning_map_${this.currentLanguage.code}`

            let customSort = (item1, item2) => {
              let a = item1[field] ? item1[field].find(el => el.lm_format_id === this.learningMapFormat) : null;
              let b = item2[field] ? item2[field].find(el => el.lm_format_id === this.learningMapFormat) : null;

              let numA = a.exam.match(/\d+/g);
              let numB = b.exam.match(/\d+/g);

              numA = numA ? parseInt(numA[0], 10) : 0;
              numB = numB ? parseInt(numB[0], 10) : 0;

              return numA < numB ? -1 : numA > numB ? 1 : 0
            }

            return metaKg.filter(item => item[field] ? item[field].find(el => el.lm_format_id === this.learningMapFormat) : null).sort(customSort)
          },
            closeViewAsserModal(){
              this.assetPopupActive = null;
              document.body.classList.remove("overflow-hidden")
            },
            tagSearch(val, key) {
                console.log(val, key)
              this.$router.push(`/?${key}=${val}`);
            },
            openAssetPopup(data) {
                this.assetPopupData = data;
                this.assetPopupActive = Boolean(this.assetPopupData);
                document.body.classList.add("overflow-hidden")
            },
            updateHead() {
                this.header_component = this.asset.title
                this.header_separator = '-'
                this.$emit('updateHead')
            },
            getRelatedAssets(asset) {
                asset = asset || this.asset;
                let relatedAssets = this.asset.related_assets || [];
                let excluded = this.asset.related_assets_excluded || [];
                let title = this.asset.title
                let asset_type = this.asset.asset_type
                let description = this.asset.description
                excluded = excluded.slice();
                excluded.push(this.asset._id);
                let keywords = this.asset.keywords;
                this.$axios.post("/related-assets", {keywords, relatedAssets, excluded, title, description, asset_type}).then(res => {
                    this.related_assets = res.data;
                }).catch(e => {
                    console.error('catch_related', e.message)
                })
            },
            getAsset(assetId) {
                let id = assetId ? assetId : this.$route.params.id;
                let url = '/assets/' + id;

                this.$axios.get(url).then(res => {
                    res.data.keywords = res.data.keywords.reduce((acc, k) => {
                        if (acc.indexOf(k) === -1) {
                            acc.push(k);
                        }
                        return acc;
                    }, [])
                    res.data.academic_metadata = [];
                    this.isError = false;
                    this.isRestore = false;
                    let d = res.data;
                  if (!d.visibility) {
                    d.visibility = 'internal_only';
                  } else {
                    d.visibility = res.data.visibility ? res.data.visibility : 'internal_only'
                    this.visibility = res.data.visibility ? res.data.visibility : 'internal_only'
                  }
                  if (!d.artist_reviewed) {
                    d.artist_reviewed = false;
                  }
                  if (!d.academic_reviewed) {
                    d.academic_reviewed = false;
                  }
                  if (!d.ar_reviewed) {
                    d.ar_reviewed = false;
                  }
                  if (!d.published_variant) {
                    d.published_variant = '';
                  }
                  if (!d.published_variant_langs) {
                    d.published_variant_langs = {};
                  }
                  let locales = {};
                  for (let k in this.$store.state.languages) {
                    if (d.locales && d.locales[this.$store.state.languages[k].code]) {
                      locales[this.$store.state.languages[k].code] = {
                        name: d.locales[this.$store.state.languages[k].code].name,
                        description: d.locales[this.$store.state.languages[k].code].description,
                        primary_tags: [...new Set(d.locales[this.$store.state.languages[k].code].primary_tags)],
                        tags: [...new Set(d.locales[this.$store.state.languages[k].code].tags)]
                      };
                    } else {
                      locales[this.$store.state.languages[k].code] = {
                        name: '',
                        description: '',
                        primary_tags: [],
                        tags: []
                      }
                    }
                  }
                  d.locales = locales;
                    this.asset = d;
                    if (res.data.meta_KG && res.data.meta_KG.length) {
                        this.asset.academic_metadata = res.data.meta_KG;
                    }
                    // this.getAssetMeta()
                    this.getRelatedAssets(this.asset);
                    if (this.asset.notes && this.asset.notes.length) {
                        this.asset.notes = this.asset.notes.replace(/&amp;#13;&amp;#10;|&#13;&#10;/g, "\n")
                        this.asset.notes = this.asset.notes.replace(/,+/g, ",")
                    }
                    this.updateHead()
                }).catch(e => {
                    if (this.$store.state.user.role.name === 'Manager') {
                        this.getDeletedAsset();
                    } else {
                        this.isError = true;
                        document.querySelector('.content-wrapper').classList.add('custom-content-wrapper2')
                        console.log('catch_search', e)
                    }
                })
            },
            getDeletedAsset() {
                let id = this.$route.params.id;
                let url = '/deleted-assets/' + id;
                document.querySelector('.content-wrapper').classList.add('custom-content-wrapper2')

                this.$axios.get(url).then(res => {
                    this.isRestore = true;
                }).catch(e => {
                    this.isError = true;
                    console.log('catch_search', e)
                })
            },
            download(links, item_index, type) {
                if (this.progressData[type][item_index]) {
                    return;
                }
                this.$set(this.progressData[type], item_index, {
                    data: {},
                    total: {},
                    loaded: {},
                })

                let files = {};
                let promises = [];

                links.forEach((item, index) => {
                    let options = {
                        responseType: 'arraybuffer',
                        onDownloadProgress: (progressEvent) => {
                            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                            if (totalLength !== null) {
                                this.$set(this.progressData[type][item_index].data, index, Math.round((progressEvent.loaded * 100) / totalLength));
                                this.$set(this.progressData[type][item_index].total, index, totalLength);
                                this.$set(this.progressData[type][item_index].loaded, index, progressEvent.loaded)
                            }
                        },
                    };

                    let instance = axios.create();
                    delete instance.defaults.headers.common['Authorization'];

                    promises.push(instance.get(item.url, options).then(res => {
                        files[index] = res.data;
                    }).catch(e => {
                        console.log('download', e)
                    }))
                });

                Promise.all(promises).then((res) => {
                    this.$set(this.progressData[type][item_index], 'zip_data', {})
                    if (Object.keys(files).length === 1) {
                        const blob = new Blob([files[0]]);
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = links[0].name + links[0].ext;
                        link.click();
                        URL.revokeObjectURL(link.href);

                        this.$set(this.progressData[type][item_index].zip_data, links[0].name, 100)
                        setTimeout(() => {
                            this.progressData[type][item_index] = false;
                        }, 500)
                    } else {
                        let zip = new JSZip();
                        let zipData = {files: links.length, total: 0};
                        for (let k in files) {
                            let name = links[k].name + links[k].ext;

                            if (zip.files[name]) {
                                name = links[k].name + '_' + Math.random().toString(36).substring(5) + links[k].ext;
                            }

                            zip.file(name, files[k]);
                        }
                        this.$set(this.progressData[type][item_index], 'zip_data', zipData)
                        let zippedFiles = {};
                        zip.generateAsync({
                            type: "blob",
                            compression: "STORE",
                        }, (metadata) => {
                            if (metadata.currentFile) {
                                let data = Object.assign({}, this.progressData[type][item_index].zip_data);
                                zippedFiles[metadata.currentFile] = metadata.percent;
                                data.total = Object.values(zippedFiles).reduce((a, b) => a + b, 0);
                                this.$set(this.progressData[type][item_index], 'zip_data', data)
                            }
                        }).then((blob) => {
                            let n = {ready: "coobo", source: "source"}
                            saveAs(blob, `${this.asset.title}_${this.asset.variants[item_index].name}_${n[type]}.zip`);
                            setTimeout(() => {
                                this.progressData[type][item_index] = false;
                            }, 500)
                        }, (err) => {
                            console.log(err);

                        })
                    }
                });
            },
            downloadedStr(data) {
                if (data.zip_data && data.zip_data.files) {
                    return `Zipping ${Math.round(data.zip_data.total / data.zip_data.files)}%`;
                }
                let loaded = this.formatNumber(Object.values(data.loaded).reduce((acc, val) => {
                    acc += val;
                    return acc
                }, 0));
                let total = this.formatNumber(Object.values(data.total).reduce((acc, val) => {
                    acc += val;
                    return acc
                }, 0));
                return `Downloaded ${loaded} / ${total}`
            },
            formatNumber(num) {
                const map = [
                    {num: 1024 * 1024, str: " mb"},
                    {num: 1024 * 1024 * 1024, str: " gb"}
                ];

                let str = (num / map[0].num).toFixed(num % map[0].num > 1 ? 2 : 1) + map[0].str;

                map.forEach(m => {
                    if (num >= m.num) {
                        str = (num / m.num).toFixed(num % m.num > 1 ? 2 : 1) + m.str;
                    }
                });

                return num ? str : 0;

            },
            editVariation() {
                this.$router.push(`/${this.$route.params.id}/edit?variation=${this.$route.params.variation_id}`)
            },
            closeInfoModal(data) {
                if (data) {
                    let url = '/';
                    if (this.deleteItemType == 'academic_metadata') {
                        url += 'academic-metadata'
                    } else {
                        url += 'variants'
                    }

                    url += '/' + this.asset[this.deleteItemType][this.deleteItem].id

                    this.$axios.delete(url)
                        .then(res => {
                            this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully deleted'})

                            this.$router.push(`/${this.asset._id}`)
                        }).catch(console.error)

                }
            },
            deleteElement(type, index) {
                this.deleteItem = index;
                this.deleteItemType = type;
                this.isInfoModal = true;
            },
            closeAddRelatedAssets() {
                this.isAddRelatedAsset = false;
            },
            getDateFormat(date) {
                let d = new Date(date);
                let dateString = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
                    d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();

                return dateString;
            },
            formatBytes(files, decimals = 2) {
                let bytes = 0;
                if (!files || !files.length) return '0 KB';
                files.forEach(item => {
                    bytes += item.size;
                })

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));
                if (i === -1) {
                    return bytes + ' ' + sizes[0];
                }

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            getDuration(duration) {
                let minutes = Math.floor(duration / 60);
                let seconds = Math.floor(duration - minutes * 60);

                return minutes + ':' + seconds;
            }
        },
        computed: {
          store() {
            return store
          },
          assetData() {
              return {
                  _id: this.asset._id,
                  title: this.asset.title,
                  thumbnail: this.asset.thumbnail,
                  asset_type: this.asset.asset_type,
              }
          },
          metaKg() {
            return this.asset && this.asset.meta_KG ? this.asset.meta_KG.filter(item => item.status === 'active') : []
          },
          primaryConcepts() {
            return this.asset && this.asset.primary_concepts ? this.asset.primary_concepts.filter(item => item.status === 'active') : []
          }
        },
    }
</script>
